/**
 * Created by chen on 2018/2/27.
 */
module.exports = {
  '86': [
    { 'cid': 1, 'id': 1, 'name': '北京' },
    { 'cid': 1, 'id': 2, 'name': '天津' },
    { 'cid': 1, 'id': 3, 'name': '河北省' },
    { 'cid': 1, 'id': 4, 'name': '山西省' },
    { 'cid': 1, 'id': 5, 'name': '内蒙古自治区' },
    { 'cid': 1, 'id': 6, 'name': '辽宁省' },
    { 'cid': 1, 'id': 7, 'name': '吉林省' },
    { 'cid': 1, 'id': 8, 'name': '黑龙江省' },
    { 'cid': 1, 'id': 9, 'name': '上海' },
    { 'cid': 1, 'id': 10, 'name': '江苏省' },
    { 'cid': 1, 'id': 11, 'name': '浙江省' },
    { 'cid': 1, 'id': 12, 'name': '安徽省' },
    { 'cid': 1, 'id': 13, 'name': '福建省' },
    { 'cid': 1, 'id': 14, 'name': '江西省' },
    { 'cid': 1, 'id': 15, 'name': '山东省' },
    { 'cid': 1, 'id': 16, 'name': '河南省' },
    { 'cid': 1, 'id': 17, 'name': '湖北省' },
    { 'cid': 1, 'id': 18, 'name': '湖南省' },
    { 'cid': 1, 'id': 19, 'name': '广东省' },
    { 'cid': 1, 'id': 20, 'name': '广西壮族自治区' },
    { 'cid': 1, 'id': 21, 'name': '海南省' },
    { 'cid': 1, 'id': 22, 'name': '重庆' },
    { 'cid': 1, 'id': 23, 'name': '四川省' },
    { 'cid': 1, 'id': 24, 'name': '贵州省' },
    { 'cid': 1, 'id': 25, 'name': '云南省' },
    { 'cid': 1, 'id': 26, 'name': '西藏自治区' },
    { 'cid': 1, 'id': 27, 'name': '陕西省' },
    { 'cid': 1, 'id': 28, 'name': '甘肃省' },
    { 'cid': 1, 'id': 29, 'name': '青海省' },
    { 'cid': 1, 'id': 30, 'name': '宁夏回族自治区' },
    { 'cid': 1, 'id': 31, 'name': '新疆维吾尔自治区' },
    { 'cid': 1, 'id': 32, 'name': '台湾省' },
    { 'cid': 1, 'id': 33, 'name': '香港特别行政区' },
    { 'cid': 1, 'id': 34, 'name': '澳门特别行政区' },
    { 'cid': 2, 'id': 9999, 'name': '美国' },
    { 'cid': 3, 'id': 9998, 'name': '新加坡' }
  ],
  '1': {
    'childs': [{ 'id': 3631, 'name': '北京市' }],
    'cid': 1,
    'code': 110000,
    'id': 1,
    'level': 1,
    'name': '北京',
    'parent': 0
  },
  '2': {
    'childs': [{ 'id': 3632, 'name': '天津市' }],
    'cid': 1,
    'code': 120000,
    'id': 2,
    'level': 1,
    'name': '天津',
    'parent': 0
  },
  '3': {
    'childs': [
      { 'id': 67, 'name': '石家庄市' },
      { 'id': 68, 'name': '唐山市' },
      { 'id': 69, 'name': '秦皇岛市' },
      { 'id': 70, 'name': '邯郸市' },
      { 'id': 71, 'name': '邢台市' },
      { 'id': 72, 'name': '保定市' },
      { 'id': 73, 'name': '张家口市' },
      { 'id': 74, 'name': '承德市' },
      { 'id': 75, 'name': '沧州市' },
      { 'id': 76, 'name': '廊坊市' },
      { 'id': 77, 'name': '衡水市' },
      { 'id': 78, 'name': '定州市' },
      { 'id': 79, 'name': '辛集市' }
    ],
    'cid': 1,
    'code': 130000,
    'id': 3,
    'level': 1,
    'name': '河北省',
    'parent': 0
  },
  '4': {
    'childs': [
      {
        'id': 80,
        'name': '太原市'
      },
      {
        'id': 81,
        'name': '大同市'
      },
      {
        'id': 82,
        'name': '阳泉市'
      },
      {
        'id': 83,
        'name': '长治市'
      },
      {
        'id': 84,
        'name': '晋城市'
      },
      {
        'id': 85,
        'name': '朔州市'
      },
      {
        'id': 86,
        'name': '晋中市'
      },
      {
        'id': 87,
        'name': '运城市'
      },
      {
        'id': 88,
        'name': '忻州市'
      },
      {
        'id': 89,
        'name': '临汾市'
      },
      {
        'id': 90,
        'name': '吕梁市'
      }
    ],
    'cid': 1,
    'code': 140000,
    'id': 4,
    'level': 1,
    'name': '山西省',
    'parent': 0
  },
  '5': {
    'childs': [
      {
        'id': 91,
        'name': '呼和浩特市'
      },
      {
        'id': 92,
        'name': '包头市'
      },
      {
        'id': 93,
        'name': '乌海市'
      },
      {
        'id': 94,
        'name': '赤峰市'
      },
      {
        'id': 95,
        'name': '通辽市'
      },
      {
        'id': 96,
        'name': '鄂尔多斯市'
      },
      {
        'id': 97,
        'name': '呼伦贝尔市'
      },
      {
        'id': 98,
        'name': '巴彦淖尔市'
      },
      {
        'id': 99,
        'name': '乌兰察布市'
      },
      {
        'id': 100,
        'name': '兴安盟'
      },
      {
        'id': 101,
        'name': '锡林郭勒盟'
      },
      {
        'id': 102,
        'name': '阿拉善盟'
      }
    ],
    'cid': 1,
    'code': 150000,
    'id': 5,
    'level': 1,
    'name': '内蒙古自治区',
    'parent': 0
  },
  '6': {
    'childs': [
      {
        'id': 103,
        'name': '沈阳市'
      },
      {
        'id': 104,
        'name': '大连市'
      },
      {
        'id': 105,
        'name': '鞍山市'
      },
      {
        'id': 106,
        'name': '抚顺市'
      },
      {
        'id': 107,
        'name': '本溪市'
      },
      {
        'id': 108,
        'name': '丹东市'
      },
      {
        'id': 109,
        'name': '锦州市'
      },
      {
        'id': 110,
        'name': '营口市'
      },
      {
        'id': 111,
        'name': '阜新市'
      },
      {
        'id': 112,
        'name': '辽阳市'
      },
      {
        'id': 113,
        'name': '盘锦市'
      },
      {
        'id': 114,
        'name': '铁岭市'
      },
      {
        'id': 115,
        'name': '朝阳市'
      },
      {
        'id': 116,
        'name': '葫芦岛市'
      }
    ],
    'cid': 1,
    'code': 210000,
    'id': 6,
    'level': 1,
    'name': '辽宁省',
    'parent': 0
  },
  '7': {
    'childs': [
      {
        'id': 117,
        'name': '长春市'
      },
      {
        'id': 118,
        'name': '吉林市'
      },
      {
        'id': 119,
        'name': '四平市'
      },
      {
        'id': 120,
        'name': '辽源市'
      },
      {
        'id': 121,
        'name': '通化市'
      },
      {
        'id': 122,
        'name': '白山市'
      },
      {
        'id': 123,
        'name': '松原市'
      },
      {
        'id': 124,
        'name': '白城市'
      },
      {
        'id': 125,
        'name': '延边朝鲜族自治州'
      }
    ],
    'cid': 1,
    'code': 220000,
    'id': 7,
    'level': 1,
    'name': '吉林省',
    'parent': 0
  },
  '8': {
    'childs': [
      {
        'id': 126,
        'name': '哈尔滨市'
      },
      {
        'id': 127,
        'name': '齐齐哈尔市'
      },
      {
        'id': 128,
        'name': '鸡西市'
      },
      {
        'id': 129,
        'name': '鹤岗市'
      },
      {
        'id': 130,
        'name': '双鸭山市'
      },
      {
        'id': 131,
        'name': '大庆市'
      },
      {
        'id': 132,
        'name': '伊春市'
      },
      {
        'id': 133,
        'name': '佳木斯市'
      },
      {
        'id': 134,
        'name': '七台河市'
      },
      {
        'id': 135,
        'name': '牡丹江市'
      },
      {
        'id': 136,
        'name': '黑河市'
      },
      {
        'id': 137,
        'name': '绥化市'
      },
      {
        'id': 138,
        'name': '大兴安岭地区'
      }
    ],
    'cid': 1,
    'code': 230000,
    'id': 8,
    'level': 1,
    'name': '黑龙江省',
    'parent': 0
  },
  '9': {
    'childs': [
      {
        'id': 3633,
        'name': '上海市'
      }
    ],
    'cid': 1,
    'code': 310000,
    'id': 9,
    'level': 1,
    'name': '上海',
    'parent': 0
  },
  '10': {
    'childs': [
      {
        'id': 155,
        'name': '南京市'
      },
      {
        'id': 156,
        'name': '无锡市'
      },
      {
        'id': 157,
        'name': '徐州市'
      },
      {
        'id': 158,
        'name': '常州市'
      },
      {
        'id': 159,
        'name': '苏州市'
      },
      {
        'id': 160,
        'name': '南通市'
      },
      {
        'id': 161,
        'name': '连云港市'
      },
      {
        'id': 162,
        'name': '淮安市'
      },
      {
        'id': 163,
        'name': '盐城市'
      },
      {
        'id': 164,
        'name': '扬州市'
      },
      {
        'id': 165,
        'name': '镇江市'
      },
      {
        'id': 166,
        'name': '泰州市'
      },
      {
        'id': 167,
        'name': '宿迁市'
      }
    ],
    'cid': 1,
    'code': 320000,
    'id': 10,
    'level': 1,
    'name': '江苏省',
    'parent': 0
  },
  '11': {
    'childs': [
      {
        'id': 168,
        'name': '杭州市'
      },
      {
        'id': 169,
        'name': '宁波市'
      },
      {
        'id': 170,
        'name': '温州市'
      },
      {
        'id': 171,
        'name': '嘉兴市'
      },
      {
        'id': 172,
        'name': '湖州市'
      },
      {
        'id': 173,
        'name': '绍兴市'
      },
      {
        'id': 174,
        'name': '金华市'
      },
      {
        'id': 175,
        'name': '衢州市'
      },
      {
        'id': 176,
        'name': '舟山市'
      },
      {
        'id': 177,
        'name': '台州市'
      },
      {
        'id': 178,
        'name': '丽水市'
      }
    ],
    'cid': 1,
    'code': 330000,
    'id': 11,
    'level': 1,
    'name': '浙江省',
    'parent': 0
  },
  '12': {
    'childs': [
      {
        'id': 179,
        'name': '合肥市'
      },
      {
        'id': 180,
        'name': '芜湖市'
      },
      {
        'id': 181,
        'name': '蚌埠市'
      },
      {
        'id': 182,
        'name': '淮南市'
      },
      {
        'id': 183,
        'name': '马鞍山市'
      },
      {
        'id': 184,
        'name': '淮北市'
      },
      {
        'id': 185,
        'name': '铜陵市'
      },
      {
        'id': 186,
        'name': '安庆市'
      },
      {
        'id': 187,
        'name': '黄山市'
      },
      {
        'id': 188,
        'name': '滁州市'
      },
      {
        'id': 189,
        'name': '阜阳市'
      },
      {
        'id': 190,
        'name': '宿州市'
      },
      {
        'id': 191,
        'name': '六安市'
      },
      {
        'id': 192,
        'name': '亳州市'
      },
      {
        'id': 193,
        'name': '池州市'
      },
      {
        'id': 194,
        'name': '宣城市'
      }
    ],
    'cid': 1,
    'code': 340000,
    'id': 12,
    'level': 1,
    'name': '安徽省',
    'parent': 0
  },
  '13': {
    'childs': [
      {
        'id': 195,
        'name': '福州市'
      },
      {
        'id': 196,
        'name': '厦门市'
      },
      {
        'id': 197,
        'name': '莆田市'
      },
      {
        'id': 198,
        'name': '三明市'
      },
      {
        'id': 199,
        'name': '泉州市'
      },
      {
        'id': 200,
        'name': '漳州市'
      },
      {
        'id': 201,
        'name': '南平市'
      },
      {
        'id': 202,
        'name': '龙岩市'
      },
      {
        'id': 203,
        'name': '宁德市'
      }
    ],
    'cid': 1,
    'code': 350000,
    'id': 13,
    'level': 1,
    'name': '福建省',
    'parent': 0
  },
  '14': {
    'childs': [
      {
        'id': 204,
        'name': '南昌市'
      },
      {
        'id': 205,
        'name': '景德镇市'
      },
      {
        'id': 206,
        'name': '萍乡市'
      },
      {
        'id': 207,
        'name': '九江市'
      },
      {
        'id': 208,
        'name': '新余市'
      },
      {
        'id': 209,
        'name': '鹰潭市'
      },
      {
        'id': 210,
        'name': '赣州市'
      },
      {
        'id': 211,
        'name': '吉安市'
      },
      {
        'id': 212,
        'name': '宜春市'
      },
      {
        'id': 213,
        'name': '抚州市'
      },
      {
        'id': 214,
        'name': '上饶市'
      }
    ],
    'cid': 1,
    'code': 360000,
    'id': 14,
    'level': 1,
    'name': '江西省',
    'parent': 0
  },
  '15': {
    'childs': [
      {
        'id': 215,
        'name': '济南市'
      },
      {
        'id': 216,
        'name': '青岛市'
      },
      {
        'id': 217,
        'name': '淄博市'
      },
      {
        'id': 218,
        'name': '枣庄市'
      },
      {
        'id': 219,
        'name': '东营市'
      },
      {
        'id': 220,
        'name': '烟台市'
      },
      {
        'id': 221,
        'name': '潍坊市'
      },
      {
        'id': 222,
        'name': '济宁市'
      },
      {
        'id': 223,
        'name': '泰安市'
      },
      {
        'id': 224,
        'name': '威海市'
      },
      {
        'id': 225,
        'name': '日照市'
      },
      {
        'id': 226,
        'name': '莱芜市'
      },
      {
        'id': 227,
        'name': '临沂市'
      },
      {
        'id': 228,
        'name': '德州市'
      },
      {
        'id': 229,
        'name': '聊城市'
      },
      {
        'id': 230,
        'name': '滨州市'
      },
      {
        'id': 231,
        'name': '菏泽市'
      }
    ],
    'cid': 1,
    'code': 370000,
    'id': 15,
    'level': 1,
    'name': '山东省',
    'parent': 0
  },
  '16': {
    'childs': [
      {
        'id': 232,
        'name': '郑州市'
      },
      {
        'id': 233,
        'name': '开封市'
      },
      {
        'id': 234,
        'name': '洛阳市'
      },
      {
        'id': 235,
        'name': '平顶山市'
      },
      {
        'id': 236,
        'name': '安阳市'
      },
      {
        'id': 237,
        'name': '鹤壁市'
      },
      {
        'id': 238,
        'name': '新乡市'
      },
      {
        'id': 239,
        'name': '焦作市'
      },
      {
        'id': 240,
        'name': '濮阳市'
      },
      {
        'id': 241,
        'name': '许昌市'
      },
      {
        'id': 242,
        'name': '漯河市'
      },
      {
        'id': 243,
        'name': '三门峡市'
      },
      {
        'id': 244,
        'name': '南阳市'
      },
      {
        'id': 245,
        'name': '商丘市'
      },
      {
        'id': 246,
        'name': '信阳市'
      },
      {
        'id': 247,
        'name': '周口市'
      },
      {
        'id': 248,
        'name': '驻马店市'
      },
      {
        'id': 249,
        'name': '济源市'
      }
    ],
    'cid': 1,
    'code': 410000,
    'id': 16,
    'level': 1,
    'name': '河南省',
    'parent': 0
  },
  '17': {
    'childs': [
      {
        'id': 250,
        'name': '武汉市'
      },
      {
        'id': 251,
        'name': '黄石市'
      },
      {
        'id': 252,
        'name': '十堰市'
      },
      {
        'id': 253,
        'name': '宜昌市'
      },
      {
        'id': 254,
        'name': '襄阳市'
      },
      {
        'id': 255,
        'name': '鄂州市'
      },
      {
        'id': 256,
        'name': '荆门市'
      },
      {
        'id': 257,
        'name': '孝感市'
      },
      {
        'id': 258,
        'name': '荆州市'
      },
      {
        'id': 259,
        'name': '黄冈市'
      },
      {
        'id': 260,
        'name': '咸宁市'
      },
      {
        'id': 261,
        'name': '随州市'
      },
      {
        'id': 262,
        'name': '恩施土家族苗族自治州'
      },
      {
        'id': 263,
        'name': '仙桃市'
      },
      {
        'id': 264,
        'name': '潜江市'
      },
      {
        'id': 265,
        'name': '天门市'
      },
      {
        'id': 266,
        'name': '神农架林区'
      }
    ],
    'cid': 1,
    'code': 420000,
    'id': 17,
    'level': 1,
    'name': '湖北省',
    'parent': 0
  },
  '18': {
    'childs': [
      {
        'id': 267,
        'name': '长沙市'
      },
      {
        'id': 268,
        'name': '株洲市'
      },
      {
        'id': 269,
        'name': '湘潭市'
      },
      {
        'id': 270,
        'name': '衡阳市'
      },
      {
        'id': 271,
        'name': '邵阳市'
      },
      {
        'id': 272,
        'name': '岳阳市'
      },
      {
        'id': 273,
        'name': '常德市'
      },
      {
        'id': 274,
        'name': '张家界市'
      },
      {
        'id': 275,
        'name': '益阳市'
      },
      {
        'id': 276,
        'name': '郴州市'
      },
      {
        'id': 277,
        'name': '永州市'
      },
      {
        'id': 278,
        'name': '怀化市'
      },
      {
        'id': 279,
        'name': '娄底市'
      },
      {
        'id': 280,
        'name': '湘西土家族苗族自治州'
      }
    ],
    'cid': 1,
    'code': 430000,
    'id': 18,
    'level': 1,
    'name': '湖南省',
    'parent': 0
  },
  '19': {
    'childs': [
      {
        'id': 281,
        'name': '广州市'
      },
      {
        'id': 282,
        'name': '韶关市'
      },
      {
        'id': 283,
        'name': '深圳市'
      },
      {
        'id': 284,
        'name': '珠海市'
      },
      {
        'id': 285,
        'name': '汕头市'
      },
      {
        'id': 286,
        'name': '佛山市'
      },
      {
        'id': 287,
        'name': '江门市'
      },
      {
        'id': 288,
        'name': '湛江市'
      },
      {
        'id': 289,
        'name': '茂名市'
      },
      {
        'id': 290,
        'name': '肇庆市'
      },
      {
        'id': 291,
        'name': '惠州市'
      },
      {
        'id': 292,
        'name': '梅州市'
      },
      {
        'id': 293,
        'name': '汕尾市'
      },
      {
        'id': 294,
        'name': '河源市'
      },
      {
        'id': 295,
        'name': '阳江市'
      },
      {
        'id': 296,
        'name': '清远市'
      },
      {
        'id': 297,
        'name': '东莞市'
      },
      {
        'id': 298,
        'name': '中山市'
      },
      {
        'id': 299,
        'name': '潮州市'
      },
      {
        'id': 300,
        'name': '揭阳市'
      },
      {
        'id': 301,
        'name': '云浮市'
      }
    ],
    'cid': 1,
    'code': 440000,
    'id': 19,
    'level': 1,
    'name': '广东省',
    'parent': 0
  },
  '20': {
    'childs': [
      {
        'id': 302,
        'name': '南宁市'
      },
      {
        'id': 303,
        'name': '柳州市'
      },
      {
        'id': 304,
        'name': '桂林市'
      },
      {
        'id': 305,
        'name': '梧州市'
      },
      {
        'id': 306,
        'name': '北海市'
      },
      {
        'id': 307,
        'name': '防城港市'
      },
      {
        'id': 308,
        'name': '钦州市'
      },
      {
        'id': 309,
        'name': '贵港市'
      },
      {
        'id': 310,
        'name': '玉林市'
      },
      {
        'id': 311,
        'name': '百色市'
      },
      {
        'id': 312,
        'name': '贺州市'
      },
      {
        'id': 313,
        'name': '河池市'
      },
      {
        'id': 314,
        'name': '来宾市'
      },
      {
        'id': 315,
        'name': '崇左市'
      }
    ],
    'cid': 1,
    'code': 450000,
    'id': 20,
    'level': 1,
    'name': '广西壮族自治区',
    'parent': 0
  },
  '21': {
    'childs': [
      {
        'id': 316,
        'name': '海口市'
      },
      {
        'id': 317,
        'name': '三亚市'
      },
      {
        'id': 318,
        'name': '三沙市'
      },
      {
        'id': 319,
        'name': '儋州市'
      },
      {
        'id': 320,
        'name': '五指山市'
      },
      {
        'id': 321,
        'name': '琼海市'
      },
      {
        'id': 322,
        'name': '文昌市'
      },
      {
        'id': 323,
        'name': '万宁市'
      },
      {
        'id': 324,
        'name': '东方市'
      },
      {
        'id': 325,
        'name': '定安县'
      },
      {
        'id': 326,
        'name': '屯昌县'
      },
      {
        'id': 327,
        'name': '澄迈县'
      },
      {
        'id': 328,
        'name': '临高县'
      },
      {
        'id': 329,
        'name': '白沙黎族自治县'
      },
      {
        'id': 330,
        'name': '昌江黎族自治县'
      },
      {
        'id': 331,
        'name': '乐东黎族自治县'
      },
      {
        'id': 332,
        'name': '陵水黎族自治县'
      },
      {
        'id': 333,
        'name': '保亭黎族苗族自治县'
      },
      {
        'id': 334,
        'name': '琼中黎族苗族自治县'
      }
    ],
    'cid': 1,
    'code': 460000,
    'id': 21,
    'level': 1,
    'name': '海南省',
    'parent': 0
  },
  '22': {
    'childs': [
      {
        'id': 3634,
        'name': '重庆市'
      },
      {
        'id': 361,
        'name': '城口县'
      },
      {
        'id': 362,
        'name': '丰都县'
      },
      {
        'id': 363,
        'name': '垫江县'
      },
      {
        'id': 364,
        'name': '忠县'
      },
      {
        'id': 365,
        'name': '云阳县'
      },
      {
        'id': 366,
        'name': '奉节县'
      },
      {
        'id': 367,
        'name': '巫山县'
      },
      {
        'id': 368,
        'name': '巫溪县'
      },
      {
        'id': 369,
        'name': '石柱土家族自治县'
      },
      {
        'id': 370,
        'name': '秀山土家族苗族自治县'
      },
      {
        'id': 371,
        'name': '酉阳土家族苗族自治县'
      },
      {
        'id': 372,
        'name': '彭水苗族土家族自治县'
      }
    ],
    'cid': 1,
    'code': 500000,
    'id': 22,
    'level': 1,
    'name': '重庆',
    'parent': 0
  },
  '23': {
    'childs': [
      {
        'id': 373,
        'name': '成都市'
      },
      {
        'id': 374,
        'name': '自贡市'
      },
      {
        'id': 375,
        'name': '攀枝花市'
      },
      {
        'id': 376,
        'name': '泸州市'
      },
      {
        'id': 377,
        'name': '德阳市'
      },
      {
        'id': 378,
        'name': '绵阳市'
      },
      {
        'id': 379,
        'name': '广元市'
      },
      {
        'id': 380,
        'name': '遂宁市'
      },
      {
        'id': 381,
        'name': '内江市'
      },
      {
        'id': 382,
        'name': '乐山市'
      },
      {
        'id': 383,
        'name': '南充市'
      },
      {
        'id': 384,
        'name': '眉山市'
      },
      {
        'id': 385,
        'name': '宜宾市'
      },
      {
        'id': 386,
        'name': '广安市'
      },
      {
        'id': 387,
        'name': '达州市'
      },
      {
        'id': 388,
        'name': '雅安市'
      },
      {
        'id': 389,
        'name': '巴中市'
      },
      {
        'id': 390,
        'name': '资阳市'
      },
      {
        'id': 391,
        'name': '阿坝藏族羌族自治州'
      },
      {
        'id': 392,
        'name': '甘孜藏族自治州'
      },
      {
        'id': 393,
        'name': '凉山彝族自治州'
      }
    ],
    'cid': 1,
    'code': 510000,
    'id': 23,
    'level': 1,
    'name': '四川省',
    'parent': 0
  },
  '24': {
    'childs': [
      {
        'id': 394,
        'name': '贵阳市'
      },
      {
        'id': 395,
        'name': '六盘水市'
      },
      {
        'id': 396,
        'name': '遵义市'
      },
      {
        'id': 397,
        'name': '安顺市'
      },
      {
        'id': 398,
        'name': '毕节市'
      },
      {
        'id': 399,
        'name': '铜仁市'
      },
      {
        'id': 400,
        'name': '黔西南布依族苗族自治州'
      },
      {
        'id': 401,
        'name': '黔东南苗族侗族自治州'
      },
      {
        'id': 402,
        'name': '黔南布依族苗族自治州'
      }
    ],
    'cid': 1,
    'code': 520000,
    'id': 24,
    'level': 1,
    'name': '贵州省',
    'parent': 0
  },
  '25': {
    'childs': [
      {
        'id': 403,
        'name': '昆明市'
      },
      {
        'id': 404,
        'name': '曲靖市'
      },
      {
        'id': 405,
        'name': '玉溪市'
      },
      {
        'id': 406,
        'name': '保山市'
      },
      {
        'id': 407,
        'name': '昭通市'
      },
      {
        'id': 408,
        'name': '丽江市'
      },
      {
        'id': 409,
        'name': '普洱市'
      },
      {
        'id': 410,
        'name': '临沧市'
      },
      {
        'id': 411,
        'name': '楚雄彝族自治州'
      },
      {
        'id': 412,
        'name': '红河哈尼族彝族自治州'
      },
      {
        'id': 413,
        'name': '文山壮族苗族自治州'
      },
      {
        'id': 414,
        'name': '西双版纳傣族自治州'
      },
      {
        'id': 415,
        'name': '大理白族自治州'
      },
      {
        'id': 416,
        'name': '德宏傣族景颇族自治州'
      },
      {
        'id': 417,
        'name': '怒江傈僳族自治州'
      },
      {
        'id': 418,
        'name': '迪庆藏族自治州'
      }
    ],
    'cid': 1,
    'code': 530000,
    'id': 25,
    'level': 1,
    'name': '云南省',
    'parent': 0
  },
  '26': {
    'childs': [
      {
        'id': 419,
        'name': '拉萨市'
      },
      {
        'id': 420,
        'name': '日喀则市'
      },
      {
        'id': 421,
        'name': '昌都市'
      },
      {
        'id': 422,
        'name': '林芝市'
      },
      {
        'id': 423,
        'name': '山南市'
      },
      {
        'id': 424,
        'name': '那曲地区'
      },
      {
        'id': 425,
        'name': '阿里地区'
      }
    ],
    'cid': 1,
    'code': 540000,
    'id': 26,
    'level': 1,
    'name': '西藏自治区',
    'parent': 0
  },
  '27': {
    'childs': [
      {
        'id': 426,
        'name': '西安市'
      },
      {
        'id': 427,
        'name': '铜川市'
      },
      {
        'id': 428,
        'name': '宝鸡市'
      },
      {
        'id': 429,
        'name': '咸阳市'
      },
      {
        'id': 430,
        'name': '渭南市'
      },
      {
        'id': 431,
        'name': '延安市'
      },
      {
        'id': 432,
        'name': '汉中市'
      },
      {
        'id': 433,
        'name': '榆林市'
      },
      {
        'id': 434,
        'name': '安康市'
      },
      {
        'id': 435,
        'name': '商洛市'
      }
    ],
    'cid': 1,
    'code': 610000,
    'id': 27,
    'level': 1,
    'name': '陕西省',
    'parent': 0
  },
  '28': {
    'childs': [
      {
        'id': 436,
        'name': '兰州市'
      },
      {
        'id': 437,
        'name': '嘉峪关市'
      },
      {
        'id': 438,
        'name': '金昌市'
      },
      {
        'id': 439,
        'name': '白银市'
      },
      {
        'id': 440,
        'name': '天水市'
      },
      {
        'id': 441,
        'name': '武威市'
      },
      {
        'id': 442,
        'name': '张掖市'
      },
      {
        'id': 443,
        'name': '平凉市'
      },
      {
        'id': 444,
        'name': '酒泉市'
      },
      {
        'id': 445,
        'name': '庆阳市'
      },
      {
        'id': 446,
        'name': '定西市'
      },
      {
        'id': 447,
        'name': '陇南市'
      },
      {
        'id': 448,
        'name': '临夏回族自治州'
      },
      {
        'id': 449,
        'name': '甘南藏族自治州'
      }
    ],
    'cid': 1,
    'code': 620000,
    'id': 28,
    'level': 1,
    'name': '甘肃省',
    'parent': 0
  },
  '29': {
    'childs': [
      {
        'id': 450,
        'name': '西宁市'
      },
      {
        'id': 451,
        'name': '海东市'
      },
      {
        'id': 452,
        'name': '海北藏族自治州'
      },
      {
        'id': 453,
        'name': '黄南藏族自治州'
      },
      {
        'id': 454,
        'name': '海南藏族自治州'
      },
      {
        'id': 455,
        'name': '果洛藏族自治州'
      },
      {
        'id': 456,
        'name': '玉树藏族自治州'
      },
      {
        'id': 457,
        'name': '海西蒙古族藏族自治州'
      }
    ],
    'cid': 1,
    'code': 630000,
    'id': 29,
    'level': 1,
    'name': '青海省',
    'parent': 0
  },
  '30': {
    'childs': [
      {
        'id': 458,
        'name': '银川市'
      },
      {
        'id': 459,
        'name': '石嘴山市'
      },
      {
        'id': 460,
        'name': '吴忠市'
      },
      {
        'id': 461,
        'name': '固原市'
      },
      {
        'id': 462,
        'name': '中卫市'
      }
    ],
    'cid': 1,
    'code': 640000,
    'id': 30,
    'level': 1,
    'name': '宁夏回族自治区',
    'parent': 0
  },
  '31': {
    'childs': [
      {
        'id': 463,
        'name': '乌鲁木齐市'
      },
      {
        'id': 464,
        'name': '克拉玛依市'
      },
      {
        'id': 465,
        'name': '吐鲁番市'
      },
      {
        'id': 466,
        'name': '哈密市'
      },
      {
        'id': 467,
        'name': '昌吉回族自治州'
      },
      {
        'id': 468,
        'name': '博尔塔拉蒙古自治州'
      },
      {
        'id': 469,
        'name': '巴音郭楞蒙古自治州'
      },
      {
        'id': 470,
        'name': '阿克苏地区'
      },
      {
        'id': 471,
        'name': '克孜勒苏柯尔克孜自治州'
      },
      {
        'id': 472,
        'name': '喀什地区'
      },
      {
        'id': 473,
        'name': '和田地区'
      },
      {
        'id': 474,
        'name': '伊犁哈萨克自治州'
      },
      {
        'id': 475,
        'name': '塔城地区'
      },
      {
        'id': 476,
        'name': '阿勒泰地区'
      },
      {
        'id': 477,
        'name': '石河子市'
      },
      {
        'id': 478,
        'name': '阿拉尔市'
      },
      {
        'id': 479,
        'name': '图木舒克市'
      },
      {
        'id': 480,
        'name': '五家渠市'
      },
      {
        'id': 481,
        'name': '北屯市'
      },
      {
        'id': 482,
        'name': '铁门关市'
      },
      {
        'id': 483,
        'name': '双河市'
      },
      {
        'id': 484,
        'name': '可克达拉市'
      },
      {
        'id': 485,
        'name': '昆玉市'
      }
    ],
    'cid': 1,
    'code': 650000,
    'id': 31,
    'level': 1,
    'name': '新疆维吾尔自治区',
    'parent': 0
  },
  '32': {
    'childs': [
      {
        'id': 486,
        'name': '台北市'
      },
      {
        'id': 487,
        'name': '高雄市'
      },
      {
        'id': 488,
        'name': '台南市'
      },
      {
        'id': 489,
        'name': '台中市'
      },
      {
        'id': 490,
        'name': '南投县'
      },
      {
        'id': 491,
        'name': '基隆市'
      },
      {
        'id': 492,
        'name': '新竹市'
      },
      {
        'id': 493,
        'name': '嘉义市'
      },
      {
        'id': 494,
        'name': '新北市'
      },
      {
        'id': 495,
        'name': '宜兰县'
      },
      {
        'id': 496,
        'name': '新竹县'
      },
      {
        'id': 497,
        'name': '桃园市'
      },
      {
        'id': 498,
        'name': '苗栗县'
      },
      {
        'id': 499,
        'name': '彰化县'
      },
      {
        'id': 500,
        'name': '嘉义县'
      },
      {
        'id': 501,
        'name': '云林县'
      },
      {
        'id': 502,
        'name': '屏东县'
      },
      {
        'id': 503,
        'name': '台东县'
      },
      {
        'id': 504,
        'name': '花莲县'
      },
      {
        'id': 505,
        'name': '澎湖县'
      }
    ],
    'cid': 1,
    'code': 710000,
    'id': 32,
    'level': 1,
    'name': '台湾省',
    'parent': 0
  },
  '33': {
    'childs': [
      {
        'id': 506,
        'name': '中西区'
      },
      {
        'id': 507,
        'name': '东区'
      },
      {
        'id': 508,
        'name': '九龙城区'
      },
      {
        'id': 509,
        'name': '观塘区'
      },
      {
        'id': 510,
        'name': '南区'
      },
      {
        'id': 511,
        'name': '深水埗区'
      },
      {
        'id': 512,
        'name': '湾仔区'
      },
      {
        'id': 513,
        'name': '黄大仙区'
      },
      {
        'id': 514,
        'name': '油尖旺区'
      },
      {
        'id': 515,
        'name': '离岛区'
      },
      {
        'id': 516,
        'name': '葵青区'
      },
      {
        'id': 517,
        'name': '北区'
      },
      {
        'id': 518,
        'name': '西贡区'
      },
      {
        'id': 519,
        'name': '沙田区'
      },
      {
        'id': 520,
        'name': '屯门区'
      },
      {
        'id': 521,
        'name': '大埔区'
      },
      {
        'id': 522,
        'name': '荃湾区'
      },
      {
        'id': 523,
        'name': '元朗区'
      }
    ],
    'cid': 1,
    'code': 810000,
    'id': 33,
    'level': 1,
    'name': '香港特别行政区',
    'parent': 0
  },
  '34': {
    'childs': [
      {
        'id': 524,
        'name': '澳门半岛'
      },
      {
        'id': 525,
        'name': '氹仔'
      },
      {
        'id': 526,
        'name': '路氹城'
      },
      {
        'id': 527,
        'name': '路环'
      }
    ],
    'cid': 1,
    'code': 820000,
    'id': 34,
    'level': 1,
    'name': '澳门特别行政区',
    'parent': 0
  },
  '9998': {
    'childs': [
      {
        'id': 2001,
        'name': '新加坡市'
      }
    ],
    'cid': 3,
    'code': 999998,
    'id': 98,
    'level': 1,
    'name': '新加坡',
    'parent': 0
  },
  '9999': {
    'childs': [
      {
        'id': 3635,
        'name': '硅谷市'
      }
    ],
    'cid': 2,
    'code': 999999,
    'id': 99,
    'level': 1,
    'name': '美国',
    'parent': 0
  }
}
